module.exports = __webpack_public_path__ + "static/img/logo_dgcp.5d7465f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_dgcp.png
// module id = FILb
// module chunks = 0